module.exports = __webpack_public_path__ + "static/media/chat.864fc0af.png";